export * from './error-404.component';
export * from './error-404.module';
